import { addressFragment } from '../fragments/address'

const mutation = `mutation customerAddressUpdate($address: CustomerAddressInput, $addressId: ID!, $defaultAddress: Boolean) {
  customerAddressUpdate(address: $address, addressId: $addressId, defaultAddress: $defaultAddress) {
    customerAddress {
        ${addressFragment}
    }
    userErrors {
      field
      message
    }
  }
}`

export default mutation
